// artifacts-draft-preview: פס "טיוטה · גרסה N, לא חיה" בראש מסך היצירה כשהיוצר פותח גרסה שאינה החיה (?version=N).
// "פרסם" (טיוטה בלבד) — משפט אישור שאומר מה מוחלף, ואז POST …/publish (אותו מסלול כמו artifact.publish של אייבי).
import { useState } from 'react';
import { Link } from 'react-router';
import { api } from '../lib/api.ts';
import { T } from '../lib/strings.ts';
import { Button } from './ui/button.tsx';
import { ErrorView } from './Status.tsx';
import { IconLayers } from './brand/icons.tsx';

export function DraftBanner({ slug, version, draft, live, onPublished }: { slug: string; version: number; draft: boolean; live: number | null; onPublished: (v: number) => void }) {
  const [confirm, setConfirm] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<unknown>(null);

  async function publish() {
    setBusy(true);
    setErr(null);
    try {
      const r = await api.publish(slug, version);
      onPublished(r.currentVersion);
    } catch (e) {
      setErr(e);
      setBusy(false);
    }
  }

  return (
    <div role="status" className="flex flex-col gap-3 rounded-md border-2 border-degraded/50 bg-degraded/[0.08] p-3 md:p-4" data-testid="draft-banner" data-version={version}>
      <div className="flex flex-wrap items-center gap-x-3 gap-y-2">
        <span aria-hidden="true" className="grid size-9 shrink-0 place-items-center rounded-md bg-degraded/15 text-degraded">
          <IconLayers size={18} />
        </span>
        <div className="me-auto flex min-w-0 flex-col">
          <strong className="text-[15px]" data-testid="draft-title">
            {draft ? T.artifact.draftBanner(version) : T.artifact.oldBanner(version)}
          </strong>
          <span className="text-sm text-muted-foreground">{T.artifact.draftHint(live)}</span>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          {live != null && (
            <Link to={`/artifacts/${encodeURIComponent(slug)}`} className="inline-flex min-h-11 items-center rounded-sm px-3 text-sm font-medium text-primary hover:bg-primary-soft" data-testid="draft-back">
              {T.artifact.backToLive}
            </Link>
          )}
          {draft && !confirm && (
            <Button size="sm" onClick={() => setConfirm(true)} data-testid="draft-publish">
              {T.artifact.publish}
            </Button>
          )}
        </div>
      </div>
      {confirm && (
        <div role="alertdialog" aria-label={T.artifact.publish} className="flex flex-col gap-3 rounded-md border border-border bg-card p-3" data-testid="publish-confirm">
          <p className="m-0 text-sm">{T.artifact.publishConfirm(version, live)}</p>
          {err != null && <ErrorView error={err} />}
          <div className="flex flex-wrap justify-end gap-2">
            <Button variant="ghost" size="sm" onClick={() => setConfirm(false)} disabled={busy}>
              {T.artifact.publishNo}
            </Button>
            <Button size="sm" onClick={() => void publish()} disabled={busy} data-testid="publish-yes">
              {T.artifact.publishYes}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}
